import { FC } from "react";

import { DynamicInputProps } from "../types";



const RadioInputComp: FC<DynamicInputProps> = ({ name, label, answers, render_condition, data_required, display, isHidden, id, group, state, updateValue }): JSX.Element => {
  return display ? (
    <div className={`form-group row py-3 ${render_condition !== "" ? "bg-light" : ""} ${isHidden ? "d-none" : ""}`}>
      <label htmlFor={`precert[${name}]`} className="col-sm-4 form-label precert-form-label">
        {label} {data_required && "*"}
      </label>
      <div className="col-sm-4">
        {answers && answers.split(",").map((answer, index) => (
          <div className="form-check form-check-inline" key={index}>
            <input 
              className="form-check-input" 
              required={data_required}
              type="radio" 
              name={name}
              id={`${name}${index}`}
              // checked={state[name] === answer.trim() || value === answer.trim()}
              checked={state[name] === answer.trim()}
              onChange={(e) => {
                if (e.target.checked)
                  updateValue(answer.trim(), id, group);
              }}
            />
            <label className="form-check-label" htmlFor={`${name}${index}`}>
              {answer}
            </label>
          </div>
        ))}
      </div>
    </div>
  ) : <></>
}

export default RadioInputComp
